import _ from 'underscore';
import strongTemplate from '../template/strong.pug';

/* @this Fomatter */
function formatInteger(v) {
  return this.i18n.formatDecimal(v, {
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
  });
}

/* @this Fomatter */
function formatDecimal(v) {
  return this.i18n.formatDecimal(v, {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  });
}

/* @this Fomatter */
function formatIntegerPercent(v) {
  return this.i18n.formatPercent(v / 100, {
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
  });
}

/* @this Fomatter */
function formatDecimalPercent(v) {
  return this.i18n.formatPercent(v / 100, {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  });
}

/* @this Fomatter */
function addSign(v) {
  return this.value > 0 ? `+${v}` : v;
}

/* @this Fomatter */
function toStrong(v) {
  return strongTemplate({ text: v });
}

/* @this Fomatter */
function format(value, functions) {
  this.value = value;
  return _.reduce(
    functions,
    (memo, func) => func.call(this, memo),
    value
  );
}

export class Formatter {
  constructor(i18n) {
    this.i18n = i18n;
    this.value = null;
  }

  formatValueWithType(value, type) {
    const typeMethodMap = {
      conversion: this.formatConversion,
      conversionDelta: this.formatConversionDelta,
      cost: this.formatCost,
      costDelta: this.formatCostDelta,
      costPerConversion: this.formatCostPerConversion,
      costPerConversionDelta: this.formatCostPerConversionDelta,
    };

    if (_.isUndefined(typeMethodMap[type])) {
      throw new Error(`Can not format. You should add configuration of this type. The type is: ${type}`);
    }
    return typeMethodMap[type].call(this, value);
  }

  formatConversionRate(value) {
    return format.call(this, value, [formatDecimalPercent, toStrong]);
  }

  formatConversion(value) {
    return format.call(this, value, [formatInteger, toStrong]);
  }
  formatConversionDelta(value) {
    return format.call(this, value, [Math.abs, formatInteger, toStrong]);
  }

  formatCost(value) {
    return format.call(this, value, [formatDecimal, toStrong]);
  }
  formatCostDelta(value) {
    return format.call(this, value, [Math.abs, formatDecimal, toStrong]);
  }

  formatCostPerConversion(value) {
    return format.call(this, value, [formatDecimal, toStrong]);
  }
  formatCostPerConversionDelta(value) {
    return format.call(this, value, [Math.abs, formatDecimal, toStrong]);
  }

  formatBidMultiplierRange(fromValue, toValue) {
    return this.i18n.getString('BidAdjustmentOpt_Range', {
      from: format.call(this, fromValue, [formatIntegerPercent, addSign, toStrong]),
      to: format.call(this, toValue, [formatIntegerPercent, addSign, toStrong]),
    });
  }

  formatBidRange(fromValue, toValue) {
    return this.i18n.getString('BidAdjustmentOpt_Range', {
      from: format.call(this, fromValue, [formatDecimal, toStrong]),
      to: format.call(this, toValue, [formatDecimal, toStrong]),
    });
  }

  formatKeyword(value, type) {
    if (type === 'ExactMatch') {
      return `[${value}]`;
    } else if (type === 'PhraseMatch') {
      return `"${value}"`;
    }
    return value;
  }

  formatSchedulingDatetime(periodType, fromHour, toHour) {
    let i18nKey;
    const startHourStr = this.i18n.formatDate(new Date(new Date().setHours(fromHour)), {
      skeleton: 'h',
      timeZone: null,
    });
    const endHourStr = this.i18n.formatDate(new Date(new Date().setHours(toHour)), {
      skeleton: 'h',
      timeZone: null,
    });
    const model = {
      startHour: startHourStr,
      endHour: endHourStr,
    };

    if (periodType === 'Workday') {
      i18nKey = 'BidAdjustmentOpt_Scheduling_Datetime_Range_Workday';
    } else if (periodType === 'Weekend') {
      i18nKey = 'BidAdjustmentOpt_Scheduling_Datetime_Range_Weekend';
    }

    return this.i18n.getString(i18nKey, model);
  }
}
